export default "__VITE_ASSET__CpugM7rs__"